export default {
  stepper: {
    description: 'Onboarding ristorante',
    steps: {
      confirm_email: 'Conferma indirizzo email',
      add_store_details: 'Aggiungi i dettagli del negozio',
      add_personal_details: 'Aggiungi le tue informazioni personali',
      add_bank_details: 'Aggiungi dati bancari per i pagamenti',
      add_tax_details: 'La tua attività è registrata ai fini IVA?',
      upload_business_doc: "Documento comprovante l'attività",
      upload_personal_doc: 'Documento di identità',
      confirm_details: 'Ricevi i pagamenti',
    },
  },
  toasts: {
    failed_to_skip_verification_step: 'Impossibile saltare la fase di verifica. Riprova',
  },
};
